

function About() {
  return (
    <div className='about-container'>
        <h1>About Me</h1>
        <p>Hi, I'm Jonathan MacDuff, an autistic full-stack software 
        developer with a background 
        in sales and a unique mind built for breaking things down and improving them.</p>

        <p>Before I decided to dive head-first into the world of software development, 
        I was (and am) a decicated, successful sales representative. 
        For the past eight years, I've been the top-performing salesperson at my 
        company; not because I'm naturally outgoing, but because I taught myself how to 
        succeed in a space that didn't come naturally. I built a system and adapted my 
        approach over time. I learned how to turn my strengths - pattern recognition 
        and rapid learning - into real-world results. After a tough first month, 
        I had solved my sales role. I've held the #1 spot ever since, and now 
        consistently generate more than twice the business of any of my peers.</p>

        <p>Now, I'm transitioning into full-stack software development: a field 
        that <em>does</em> come naturally to me. I've always been drawn to complex 
        systems and logical structure. Coding gives me the kind of deep, problem-solving 
        engagement I've always looked for in my work.</p>

        <p>My autism is a huge part of how my brain works; it shapes how I see problems 
        and build solutions. I don't see it as a disability; to the contrary, my autism helps me spot patterns and break down systems, 
        approaching challenges from unconventional angles. That's what my domain name 
        is about: autism isn't just a diagnosis, it's a way of thinking that brings 
        real value to my technical work.</p>

        <p>In my sales role, I also developed strong communication skills; not just 
        persuasion, but real, practiced interpersonal clarity. I had to learn how to 
        listen, and how to translate complex ideas. This process taught me how to 
        connect with people in ways that I couldn't before. That work now informs 
        how I communicate and collaborate, no matter the context.</p>

        <p>I'm still early in my development career, but I learn fast and think deeply. 
        I'm looking for a team that values honesty, curiosity, and growth; 
        one where I can make meaningful contributions.</p>
    </div>
  );
};

export default About;